import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import PropTypes from 'prop-types';
import { useMemo, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

DoughnutChartJS.propTypes = {
  title: PropTypes.string,
  showTitle: PropTypes.bool,
  labels: PropTypes.array,
  datasets: PropTypes.array,
  showLegend: PropTypes.bool,
};

/**
 *
 * @param {{
 *  title: string,
 *  showTitle: boolean,
 *  labels: string[],
 *  datasets: {
 *    label: string,
 *    data: number[],
 *    borderWidth: number,
 *    borderColor: string,
 *    backgroundColor: string,
 *    borderRadius: number,
 *  }[],
 * }} props
 * @returns
 */
function DoughnutChartJS({
  title = '',
  showTitle = true,
  labels = [],
  datasets = [],
  showLegend = true,
}) {
  // MARK: --- Params ---
  const refChart = useRef();
  const options = useMemo(() => {
    return {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
          display: showLegend,
          labels: {
            font: {
              size: 13,
              family: 'IBM Plex Sans',
            },
          },
        },
        title: {
          display: showTitle,
          text: title,
          color: '#181C32',
        },
        tooltip: {
          padding: 10,
          backgroundColor: '#fff',
          titleColor: '#3F4254',
          titleFont: {
            size: 13,
            family: 'IBM Plex Sans',
            lineHeight: 1.2,
          },
          titleMarginBottom: 4,
          bodyColor: '#3F4254',
          bodySpacing: 4,
          bodyFont: {
            size: 12,
            family: 'IBM Plex Sans',
            lineHeight: 1.2,
          },
          borderWidth: 1,
          borderColor: '#EBEDF3',
        },
      },
      // responsive
      maintainAspectRatio: false,
    };
  }, [title, showTitle]);
  const data = useMemo(() => {
    return {
      labels: labels,
      datasets: datasets.map((item) => {
        const dataset = {
          label: item.label ?? '',
          data: item.data ?? [],
          borderWidth: item.borderWidth ?? 2,
          borderColor: item.borderColor,
          backgroundColor: item.backgroundColor,
          borderRadius: item.borderRadius ?? 0,
        };
        return dataset;
      }),
    };
  }, [labels, datasets]);

  return (
    <div className="h-100">
      <Doughnut options={options} data={data} ref={refChart} />
    </div>
  );
}

export default DoughnutChartJS;
